import moment from 'moment';
import { isNull } from '../../common/util';

interface DateCoercer {
    toStr: (obj?) => string;
    fromStr: (obj?) => string | null;
    isValidStr: () => boolean;
}

function isHtml5DateSupported() {
    let input = document.createElement('input');
    input.setAttribute('type', 'date');

    let notADateValue = 'not-a-date';
    input.setAttribute('value', notADateValue);

    return input.value !== notADateValue;
}

const HTML5DateCoercer: DateCoercer = {
    toStr(obj) {
        if (isNull(obj)) {
            return '';
        }
        return moment(obj, ['DD.MM.YYYY'], true).format('YYYY-MM-DD');
    },

    fromStr(str) {
        if (!str) {
            return null;
        }
        return moment(str, ['YYYY-MM-DD'], true).format('DD.MM.YYYY');
    },

    isValidStr() {
        return true;
    }
};

export function getDateCoercer(): DateCoercer {
    if (isHtml5DateSupported()) {
        return HTML5DateCoercer;
    }

    return undefined;
}
